module.exports = __webpack_public_path__ + "static/simufact05-2f8fa0b8cd89a8bfa6b864e46fe50a28.png";